function setStorageItem(args: { key: string; value: unknown; storage: 'local' | 'session' }) {
  const storage = args.storage === 'local' ? localStorage : sessionStorage;
  const value = JSON.stringify(args.value);
  storage.setItem(args.key, value);
}

function getStorageItem<T = any>(args: { key: string; storage: 'local' | 'session' }) {
  if (typeof window === 'undefined') return;
  const storage = args.storage === 'local' ? localStorage : sessionStorage;
  const value = storage.getItem(args.key);
  if (typeof value === 'string') {
    try {
      return JSON.parse(value) as T;
    } catch {
      return;
    }
  } else return;
}

export { getStorageItem, setStorageItem };
